import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
@Injectable()
export class AdminAuthGuardService implements CanActivate {
    constructor(public router: Router) { }
    canActivate(): boolean {
        let isAdmin = localStorage.getItem('isAdmin');
        if (isAdmin === 'true') {
            return true;
        }
        this.router.navigate(['login']);
        return false;
    }
}